import {Component, Input, OnInit} from '@angular/core';
import {CommonService} from '@app/feature/store-editor/services/common.service';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';

@Component({
  selector: 'app-sub-component-container',
  templateUrl: './sub-component-container.component.html',
  styleUrls: ['./sub-component-container.component.css']
})
export class SubComponentContainerComponent implements OnInit {

  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  constructor(public cs: CommonService) { }


  ngOnInit() {
    this.item.data = this.cs.setDefaultSetting(this.item.data);
  }

  addUrl(image: string) {
    return 'url("' + image + '")';
  }
}
